import axios from 'axios'
import helpers from "@/helpers";

export default {
    getUser({commit}) {

        axios.get(process.env.VUE_APP_API_URL + `/user`)
            .then(response => commit('storeUsers', response.data.data))
    },
    saveUser({commit}, user) {
        axios.patch(process.env.VUE_APP_API_URL + `/user/${user.id}`, user)
            .then(() => {
                helpers.handleSuccessMessage("Die Berechtigungen für den Benutzter wurden gespeichert!", "Gespeichert")
            })
            .catch(() => {
                helpers.handleWarningMessage("Die Berechtigungen für den Benutzter wurden nicht gespeichert!", "Fehler")
            })
        commit('none')
    }
}
